import request from '@/api/axios';
export function getUnlockProduct(country) {
    return request({
        url: '/api/order/v1/unlockOrder/getUnlockOrderPayByProductCode?country=' + country,
        method: 'get'
    });
}
export function getUnlockProductPayMethod(productId) {
    return request({
        url: '/api/order/v1/unlockOrder/getUnlockProductPayMethod?productId=' + productId,
        method: 'get'
    });
}

export function payForUnlockOrder(param) {
    return request({
        url: '/api/order/v1/unlockOrder/payForOrder',
        method: 'post',
        data: param
    });
}

export function getAntomSubscribeResult(order) {
    return request({
        url: `/api/order/v1/order/getAntomSubscribeResult/${order}`,
        method: 'get'
    });
}


export function getOrderPayByProductCode(productCode, iccid, autoRenew,ruleBindId) {
    return request({
        url: '/api/order/v1/order/getOrderPayByProductCode?productCode=' + productCode + "&iccid=" + iccid + "&autoRenew=" + autoRenew + "&ruleBindId=" + ruleBindId,
        method: 'get'
    });
}

export function getPayMethod(productCode, autoRenew) {
    return request({
        url: '/api/order/v1/order/getPayMethod?productCode=' + productCode + "&autoRenew=" + autoRenew,
        method: 'get'
    });
}

export function getOrderPayByProductCodeAndPayMethod(productCode, iccid, methodType) {
    return request({
        url: '/api/order/v1/order/getOrderPayByProductCodeAndPayMethod?productCode=' + productCode + "&iccid=" + iccid + "&methodType=" + methodType,
        method: 'get'
    });
}

export function getOrderByIccid(iccid) {
    return request({
        url: '/api/order/v1/order/getOrderByIccid?iccid=' + iccid,
        method: 'get'
    });
}

export function getOrderByOrderNo(orderNo) {
    return request({
        url: `/api/order/v1/order/getOrderByOrderNo/${orderNo}`,
        method: 'get'
    });
}

export function payForOrder(param, headers = {}) {
    return request({
        url: '/api/order/v1/order/payForOrder',
        method: 'post',
        data: param,
        headers
    });
}

export function restartPayment(orderNo) {
    return request({
        url: `/api/order/v1/order/restartPayment?orderNo=${encodeURIComponent(orderNo)}`,
        method: 'post',
    });
}

export function cancelForOrder(iccid) {
    return request({
        url: `/api/order/v1/order/cancelSubscription/${iccid}`,
        method: 'post',
    });
}



export function getPayResult(orderNo) {
    return request({
        url: `/api/order/v1/unlockOrder/getPayResult/${orderNo}`,
        method: 'get',
    });
}

export function reportBuriedPoint(orderNo) {
    return request({
        url: `/api/order/v1/order/reportBuriedPoint/${orderNo}`,
        method: 'get',
    });
}


export function getUnlockDeviceStatus(deviceId) {
    return request({
        url: `/api/order/v1/unlockOrder/getUnlockDeviceStatus/${deviceId}`,
        method: 'get',
    });
}
